import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { FadeUp } from "./Motion";

export const PillButton = ({ to, children, variant = "primary", testId, className = "" }) => {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold transition-colors duration-200";
  const styles =
    variant === "primary"
      ? "bg-ol-blue text-white shadow-[0_16px_40px_-12px_rgba(37,99,235,0.7)] hover:bg-ol-deep"
      : "bg-white text-ol-ink border border-gray-200 hover:border-ol-blue hover:text-ol-blue";
  return (
    <Link to={to} data-testid={testId} className={`${base} ${styles} ${className}`}>
      {children}
      <ArrowRight size={18} weight="bold" className="transition-transform duration-200 group-hover:translate-x-1" />
    </Link>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-2 rounded-full bg-ol-blue/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-ol-blue ${className}`}>
    {children}
  </span>
);

export const CTASection = ({
  title = "Ready to lease the simple way?",
  subtitle = "Be first in line when OneLease opens. Join the waitlist and skip the paperwork forever.",
  testId = "cta-section",
}) => (
  <section data-testid={testId} className="px-5 sm:px-8 py-20 sm:py-28">
    <div className="mx-auto max-w-6xl">
      <FadeUp className="relative overflow-hidden rounded-[2.5rem] bg-ol-deep px-7 py-16 sm:px-16 sm:py-20 grain">
        <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-ol-blue/40 blur-3xl" />
        <div className="absolute -left-10 bottom-0 h-52 w-52 rounded-full bg-ol-blue/20 blur-3xl" />
        <div className="relative z-10 max-w-2xl">
          <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white leading-[1.05]">
            {title}
          </h2>
          <p className="mt-5 text-lg text-white/70 leading-relaxed">{subtitle}</p>
          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <PillButton to="/waitlist" testId={`${testId}-waitlist`}>Join the Waitlist</PillButton>
            <Link
              to="/faq"
              data-testid={`${testId}-faq`}
              className="inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold text-white/80 border border-white/20 hover:bg-white/10 transition-colors duration-200"
            >
              Read the FAQ
            </Link>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);
